import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Container,
  Breadcrumbs,
  Link,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import { 
  Fingerprint as FingerprintIcon,
  CheckCircle as CheckIcon,
  Email as EmailIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon,
  Article as BlogIcon,
} from '@mui/icons-material';

export const BackgroundChecks = () => {
  const handleContactUs = () => {
    window.open('mailto:sales@driververified.com', '_blank');
  };

  const documents = [
    {
      title: "Driver's Abstracts/Motor Vehicle Abstracts (MVRs)",
      subtitle: "Available from all provinces with the exception of Alberta",
    },
    {
      title: "Commercial Vehicle Operator Registration Driving Record (CVORDR)",
    },
    {
      title: "Criminal Record Checks (any jurisdiction in Canada)",
    },
    {
      title: "Employment Reference (any jurisdiction in Canada)",
    },
  ];

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 3 }}>
        <Link 
          color="inherit" 
          href="/services" 
          sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
        >
          Services
        </Link>
        <Typography color="text.primary">Driver's Abstracts and Background Checks</Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
          Driver's Abstracts and Background Checks
        </Typography>
      </Box>

      {/* Main Content */}
      <Card sx={{ mb: 4, boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)' }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <FingerprintIcon sx={{ fontSize: 64, color: '#1976d2', mb: 2 }} />
            <Typography variant="body1" sx={{ maxWidth: '600px', mx: 'auto', lineHeight: 1.7 }}>
              We source the following documents for clients:
            </Typography>
          </Box>

          <List sx={{ mb: 4 }}>
            {documents.map((doc, index) => (
              <ListItem key={index} sx={{ alignItems: 'flex-start', py: 1 }}>
                <ListItemIcon sx={{ mt: 0.5 }}>
                  <CheckIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary={doc.title}
                  secondary={doc.subtitle}
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItem>
            ))}
          </List>

          <Box sx={{ textAlign: 'center', py: 4, bgcolor: '#f8f9fa', borderRadius: 2, mb: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              Contact us for pricing and more information!
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={handleContactUs}
              startIcon={<EmailIcon />}
              sx={{
                mt: 2,
                backgroundColor: '#4ecdc4',
                '&:hover': { backgroundColor: '#45b7d1' },
                px: 4,
                py: 1.5,
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
              sales@driververified.com
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Footer */}
      <Card sx={{ boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)' }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Keep in touch:
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mb: 2 }}>
            <Link href="#" color="primary" sx={{ textDecoration: 'none' }}>
              <FacebookIcon />
            </Link>
            <Link href="#" color="primary" sx={{ textDecoration: 'none' }}>
              <TwitterIcon />
            </Link>
            <Link href="#" color="primary" sx={{ textDecoration: 'none' }}>
              <InstagramIcon />
            </Link>
            <Link href="#" color="primary" sx={{ textDecoration: 'none' }}>
              <BlogIcon />
            </Link>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', mb: 2 }}>
            <Link href="#" color="primary" sx={{ textDecoration: 'none' }}>
              Policies & Terms
            </Link>
            <Typography color="text.secondary">•</Typography>
            <Link href="#" color="primary" sx={{ textDecoration: 'none' }}>
              Our Company
            </Link>
            <Typography color="text.secondary">•</Typography>
            <Link href="#" color="primary" sx={{ textDecoration: 'none' }}>
              Contact Us
            </Link>
          </Box>
          <Typography variant="caption" color="text.secondary">
            Copyright © 2018-2025 Driver Verified Inc.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
}; 